import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { template } from "lodash";
import { AuthService } from "../../../services/auth.service";
import { SearchService } from "../../../../global/services/data/search-service/searchservice";
import { GenericButtonComponent } from "../../../../global/component/generic/generic-button/generic-button.component";
import { CardModule } from "primeng/card";
import { ToastModule } from "primeng/toast";
import { MessageService } from "primeng/api";

@Component({
    selector: 'app-download-report',
    standalone: true,
    templateUrl:'./download-report.component.html',
    imports: [GenericButtonComponent, CardModule, ToastModule]
  })
  export class DownloadReportComponent{
  fileName!:string;
    constructor(private router:Router, private route: ActivatedRoute,  
         protected searchService:SearchService,  private authService: AuthService,
         private messageService: MessageService){
        this.fileName = this.route.snapshot.queryParams['fileName']?? '';
    }
    onDownload() {
        this.searchService.getReportDownloadUrl(this.fileName).subscribe({
          next: (blob) => {
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = this.fileName;
            a.click();
            URL.revokeObjectURL(downloadUrl);
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Thank you for downloading the file.' });
          },
          error: () => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to download the file.\nPlease try again later.' });
          }
        });
    }
  }